import { CSSProperties } from 'react';

import { buttonPrimary, colors, sizes } from '../../theme';

const styles = {
  input: {
    display: 'none',
  } as CSSProperties,
  // inline-flex: no extra line height around the button, it keeps the 36px of the other buttons.
  label: {
    display: 'inline-flex',
  },
  labelFull: {
    display: 'flex',
  },
  button: {
    ...buttonPrimary,
    gap: 0.75,
  },
  buttonFull: {
    ...buttonPrimary,
    gap: 0.75,
    width: '100%',
  },
  icon: {
    fontSize: 18,
  },
  // Same round as the arrows of the feed: dark, a border, the "+" in white.
  round: {
    width: sizes.button,
    height: sizes.button,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxSizing: 'border-box',
    border: `1px solid ${colors.border}`,
    backgroundColor: colors.surfaceRaised,
    color: colors.text,
    cursor: 'pointer',
    transition: 'background-color 0.15s',
    '&:hover': {
      backgroundColor: colors.hoverItem,
    },
  },
};

export default styles;
